import React from 'react';

/**
 * Generic reusable confirmation modal.
 * @param {{ title: string, body: string, confirmLabel?: string, onConfirm: () => void, onCancel: () => void }} props
 */
export default function ConfirmDialog({ title, body, confirmLabel = 'Confirm', onConfirm, onCancel }) {
  return (
    <div
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4"
      onClick={onCancel}
    >
      <div onClick={(e) => e.stopPropagation()} className="panel p-5 max-w-sm w-full space-y-4">
        <div className="font-display font-bold text-lg">{title}</div>
        <div className="text-sm text-white/70">{body}</div>
        <div className="flex justify-end gap-2 pt-2">
          <button onClick={onCancel} className="btn-ghost">Keep editing</button>
          <button
            onClick={onConfirm}
            className="px-3 py-2 rounded-md bg-rose-500/80 hover:bg-rose-500 text-white text-sm font-medium"
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
